<!-- 联系我们 -->
<template>
	<div>
		<!-- logo区域 -->
		<logo-head></logo-head>
		<!-- 导航菜单 -->
		<nav-head></nav-head>
		<!-- banner图 -->
		<banner></banner>
		<!-- 联系我们 -->
		<div class="structure">
			<div class="structureContent">
				<div class="text-center mt-4">
					<span class="font-weight-bold" style="font-size: 24px;">联系我们</span>
				</div>
				<!-- 主体内容 -->
				<div class="mt-4">
					<div v-html="contactUsContent">
						
					</div>
				</div>
			</div>
		</div>
		<!-- footer -->
		<Footer :bgColor="'#2c68ff'"></Footer>
	</div>
</template>

<script>
	import logoHead from '../../components/logoHead/logoHead.vue'
	import navHead from '../../components/navHead/navHead.vue'
	import banner from '../../components/banner/banner.vue'
	import Footer from '../../components/footer/footer.vue'
	export default{
		components: {
			logoHead,
			navHead,
			banner,
			Footer
		},
		data() {
			return {
				contactUsContent:''
			}
		},
		mounted() {
			this.getcontactUsContent()
		},
		methods: {
			getcontactUsContent() {
				let vm = this
				vm.axios.get('/api/irpi/sys/findAbout').then(res=>{
					vm.contactUsContent = res.data.data
				})
			}
		},
	}
</script>

<style scoped>
.structure{
	width: 100%;
	min-height:600px;
	overflow: hidden;
	background-color: #F8F8F8;
}
.structure .structureContent{
	width: 1200px;
	min-height:600px;
	background-color: #fff;
	margin: 0 auto;
	margin-top: 50px;
	margin-bottom: 50px;
	padding:20px 60px;
}
</style>

